var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#8082C5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(3 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.378 1.376 4.243.003v4.242",
    transform: "matrix(-.70710678 .70710678 .70710678 .70710678 3.500179 -1.449821)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 9.49998326h5c2 .00089417 3-.99910025 3-2.99998326s-1-3.00088859-3-3.00001674h-10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkReset);
export default __webpack_public_path__ + "static/media/darkReset.b5f21b86234f6d8c43396da777c19119.svg";
export { ForwardRef as ReactComponent };